import './App.css';
import { Admin, Resource, CustomRoutes } from 'react-admin';
import { Route } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { customTheme } from './theme/customTheme';
import { authProvider } from './Provider/parseAuthProvider';
import { dataProvider } from './Provider/parseDataProvider';
import Login from './pages/auth/Login';
import OperatorManagement from './pages/operators/OperatorManagement';
import AdminOtpVerification from './pages/auth/AdminOtpVerification';
import OperatorList from './pages/operators/OperatorList';
import AdminList from './pages/admins/AdminList';
import OperatorGamesList from './pages/operatorGames/OperatorGamesList';
import Profile from './pages/profile/Profile';
import AdminActivityLogs from './pages/adminActivityLogs/AdminActivityLogs';
import { CustomLayout } from './layouts/CustomLayout';
import BusinessIcon from '@mui/icons-material/Business';
import { GameRecordList } from './pages/GameRecords/GameRecords';
import CasinoIcon from '@mui/icons-material/Casino';
import TuneIcon from '@mui/icons-material/Tune';
import { GameBetConfig } from './pages/GameBetConfig/GameBetConfig';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={customTheme}>
        <CssBaseline />
        <Admin
          authProvider={authProvider}
          dataProvider={dataProvider}
          loginPage={Login}
          layout={CustomLayout}
          theme={customTheme}
          requireAuth
        >
          <Resource name="operators" list={OperatorManagement} icon={BusinessIcon} />
          <Resource
            name="operatorGames"
            list={OperatorGamesList}
            options={{ label: 'Operator Games' }}
            icon={TuneIcon}
          />
          <Resource
            name="GameCatalogue"
            list={GameRecordList}
            options={{ label: 'Game Records' }}
            icon={CasinoIcon}
          />
          <Resource
            name="GameBetConfig"
            list={GameBetConfig}
            options={{ label: 'Game Bet Levels' }}
            icon={CurrencyExchangeIcon}
          />

          <CustomRoutes>
            <Route path="/admin-otp-verification" element={<AdminOtpVerification />} />
            <Route path="/admins" element={<AdminList />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin-activity-logs" element={<AdminActivityLogs />} />
          </CustomRoutes>
        </Admin>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
